<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">
      <slide>
        <div class="padding">
          <div>
            <p> &nbsp;</p>
            <p> I've written so much of this city, tried to fix it in place in a book for Oska.</p>
            <p>but somehow I haven't found a way to put you in it</p>
            <p>maybe I don't want to get it wrong</p>
            <p> &nbsp;</p>
            <p>I wanted to say something to you</p>
            <p>but just to you</p>
            <p>not something to be fixed, </p>
            <p>not a memory</p>
            <p>a hope</p>
            <p> &nbsp;</p>
            <p>I wrote it down, </p>
            <p> &nbsp;</p>
            <p>I tore out the page and I put it in Oska's bag</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </div>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <div>
            <span class="arch">
              <p>This city is no longer the place it was when I arrived here.</p>
              <p> &nbsp;
              This city is more complex, is an amalgam of when and where and how.</p>
              <p></p>
              <p>There is a statue of a veiled woman in a backstreet behind a market and when I first stood before it I could see its face, but no more.</p>
              <p>There are gryphons on the bridge over the river and I swear those pedestals were empty. </p>
              <p>The streets are crashing together and the river is rising. </p>
              <p> &nbsp;</p>
              <p>I turned down a street, and descended a steep hill before the roadway opened out onto this vista. </p>
              <p>A burned out gaming hall. Covered in wood and daubed with paint.</p>
              <p>There are lines on the building, and I saw something in their form. </p>
              <p>I recalled the inanities offered by the closter devoted to the word and the form of the city. I always disregarded those imbeciles, crying in the street that the architecture and lines of the city describe some monstrous design, but here, stood in this street and lost in another place, their delusions seemed less remote, more tangible. </p>
              <p>I drew the building, and found myself marking the drawing, and suddenly it all became so clear.</p>
              <p> &nbsp;</p>
              <p> &nbsp;
              This place is only an echo</p>
              <p>the image that keeps returning to me, of dust and the silence and a city falling,it is a vision of this echo fading,
              of this city falling</p>
              <p> &nbsp;</p>
              <p>and I realise that i'm living in this echo</p>
              <p>and once it is gone there will only be Portus</p>
              <p>i have to find a way back before the silence</p>
              <p>And what if I cannot make it? What if I cannot return?</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p>I search, my heart under pressure, urgency burns through me</p>
              <p>yet I fail to grasp what it is I'm looking for</p>
              <p>each street and corner and building becomes blurred</p>
              <p>as I pass them with ever increasing speed</p>
              <p>am I running? i slow down, and try to pay attention . . </p>
              <p> &nbsp;</p>
              <p>to notice, what? </p>
              <p> &nbsp;</p>
              <p>Portus? </p>
              <p> &nbsp;</p>
              <p>maybe just a trace, a source, </p>
              <p>something as fluid as me, out of place</p>
              <p>something that has shifted</p>
              <p> &nbsp;</p>
              <p>a soft boundary</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
            </span>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Search'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
